module.exports = __webpack_public_path__ + "static/privacy-35a0153b1c2ba0b3092db751f120be29.svg";